import React, { useEffect } from "react";
import Dashboard from "../Dashboard";
import { useQuery } from "react-query";
import { getMydata } from "../../actions/Login";
import { useSetRecoilState } from "recoil";
import { accountAtom } from "../Login/atoms/AccountAtom";
import { useHistory } from "react-router-dom";

const Home = () => {
  return <Dashboard />;
};
export default Home;
